import { action, Action } from 'easy-peasy';
import type { MattingOptions } from '@meitu/image-matting';
import type { AI_GENERATE_IMAGE_EXT_DATA } from '@meitu/saas-editor-core/es/version-types';

export interface IAIExpendImageInfo {
    // 扩图倍数
    multiple: number;

    // 扩图比例
    ratio: string;

    // 扩图描述
    desc: string;

    // 结果图
    resultUrl: string;

    loading: boolean;
    offsetX: number;
    offsetY: number;
}

export enum AIModifyImagePainType {
    pain,
    erase,
    none,
}

export interface IAIModifyImageInfo {
    desc: string;
    mask: string;
    painType: AIModifyImagePainType;
    painSize: number;
    loading: boolean;
    hasPain: boolean;

    // 结果图
    resultUrl: string;
}

export const DefaultAIExpendImageInfo = () => ({
    multiple: 1.25,
    ratio: '0',
    desc: '',
    resultUrl: '',
    offsetX: 0,
    offsetY: 0,
    loading: false,
});

export const DefaultAIModifyImageInfo = () => ({
    desc: '',
    mask: '',
    painType: AIModifyImagePainType.pain,
    painSize: 30,
    loading: false,
    resultUrl: '',
    hasPain: false,
});

interface FuncUseMapPrams {
    [key: string]: {
        [key: string]: {
            func: string;
            multiple?: number;
            ratio?: string;
            is_creative?: boolean;
            url?: string;
            size_num?: number;

            [key: string]: any;
        };
    };
}

export interface IPluginModel {
    aiExpendImageInfo: IAIExpendImageInfo;
    setAIExpendImageInfo: Action<IPluginModel, IAIExpendImageInfo>;
    aiModifyImageInfo: IAIModifyImageInfo;
    setAIModifyImageInfo: Action<IPluginModel, IAIModifyImageInfo>;
    funcUsedMap: FuncUseMapPrams;
    setFuncUsedMap: Action<IPluginModel, FuncUseMapPrams>;
    batchTemplateUse: number[];
    setBatchTemplateUse: Action<IPluginModel, number>;
    openImageModalType: string | null;
    setOpenImageModalType: Action<IPluginModel, string>;
    processingMattingImgInfo: MattingOptions['imageInfo'] | null;
    setProcessingMattingImgInfo: Action<IPluginModel, MattingOptions['imageInfo']>;
    clearProcessingMattingImgInfo: Action<IPluginModel>;

    isMatting: boolean;
    setIsMatting: Action<IPluginModel, boolean>;
    isMattingMainLayer: boolean;
    setIsMattingMainLayer: Action<IPluginModel, boolean>;
    aiMattingCanApply: boolean;
    setAiMattingCanApply: Action<IPluginModel, boolean>;

    openPlugName: string | null;
    setOpenPlugName: Action<IPluginModel, string | null>;
    isAiExpendImage: boolean;

    setIsAiExpendImage: Action<IPluginModel, boolean>;

    isAiModifyImage: boolean;

    setIsAiModifyImage: Action<IPluginModel, boolean>;

    isAiGenerateImage: boolean;

    setIsAiGenerateImage: Action<IPluginModel, boolean>;

    /** ai生图插件的初始化配置 */
    extDataOfAiGenerateImage: AI_GENERATE_IMAGE_EXT_DATA | null;

    setExtDataOfAiGenerateImage: Action<IPluginModel, AI_GENERATE_IMAGE_EXT_DATA | null>;
}

export const pluginModel: IPluginModel = {
    aiExpendImageInfo: DefaultAIExpendImageInfo(),
    setAIExpendImageInfo: action((state, aiExpendImageInfo) => {
        state.aiExpendImageInfo = aiExpendImageInfo;
    }),
    aiModifyImageInfo: DefaultAIModifyImageInfo(),
    setAIModifyImageInfo: action((state, aiModifyImageInfo) => {
        state.aiModifyImageInfo = aiModifyImageInfo;
    }),
    funcUsedMap: {},
    setFuncUsedMap: action((state, funcUsedMap) => {
        state.funcUsedMap = funcUsedMap;
    }),
    batchTemplateUse: [],
    setBatchTemplateUse: action((state, num) => {
        state.batchTemplateUse.push(num);
        state.batchTemplateUse = [...state.batchTemplateUse];
    }),
    openImageModalType: '',
    setOpenImageModalType: action((state, openImageModalType) => {
        state.openImageModalType = openImageModalType;
    }),
    isMatting: false,
    setIsMatting: action((state, data) => {
        state.isMatting = data;
    }),
    isMattingMainLayer: false,
    setIsMattingMainLayer: action((state, data) => {
        state.isMattingMainLayer = data;
    }),
    aiMattingCanApply: false,
    setAiMattingCanApply: action((state, data) => {
        state.aiMattingCanApply = data;
    }),
    processingMattingImgInfo: null,
    setProcessingMattingImgInfo: action((state, data) => {
        state.processingMattingImgInfo = data;
    }),
    clearProcessingMattingImgInfo: action((state) => {
        state.processingMattingImgInfo = null;
    }),
    openPlugName: null,
    setOpenPlugName: action((state, data) => {
        state.openPlugName = data;
    }),
    isAiExpendImage: false,
    isAiModifyImage: false,
    isAiGenerateImage: false,
    extDataOfAiGenerateImage: null,

    setIsAiExpendImage: action((state, isAiExpendImage) => {
        state.isAiExpendImage = isAiExpendImage;
    }),

    setIsAiModifyImage: action((state, isAiModifyImage) => {
        state.isAiModifyImage = isAiModifyImage;
    }),

    setIsAiGenerateImage: action((state, isAiGenerateImage) => {
        state.isAiGenerateImage = isAiGenerateImage;
    }),

    setExtDataOfAiGenerateImage: action((state, extDataOfAiGenerateImage) => {
        state.extDataOfAiGenerateImage = extDataOfAiGenerateImage;
    }),
};
